webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(33);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(132);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: 'body',
	  components: { App: _App2.default }
	});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLessons = getLessons;
	exports.getCompletedSectionCount = getCompletedSectionCount;
	exports.getSectionCount = getSectionCount;
	exports.getCompletedCount = getCompletedCount;
	exports.getCompleted = getCompleted;
	exports.getLessonCount = getLessonCount;
	exports.getLesson = getLesson;
	exports.getSection = getSection;
	exports.getOutput = getOutput;
	exports.getHistory = getHistory;
	exports.getSolved = getSolved;
	exports.getLessonSolved = getLessonSolved;
	exports.getTurbo = getTurbo;
	exports.getLessonSelectionActive = getLessonSelectionActive;
	exports.getDoneModalActive = getDoneModalActive;
	function getLessons(state) {
	  return state.lessons.map(function (lesson, index) {
	    return {
	      index: index,
	      title: lesson.title,
	      done: getCompleted(state).indexOf(index) > -1,
	      active: state.currentLesson === index
	    };
	  });
	}
	
	function getCompletedSectionCount(state) {
	  var c = 0;
	  if (getSolved(state)) {
	    c = 1;
	  }
	  return state.currentSection + c;
	}
	
	function getSectionCount(state) {
	  return state.lessons[state.currentLesson].sections.length;
	}
	
	function getCompletedCount(state) {
	  return state.completedLessons.length;
	}
	
	function getCompleted(state) {
	  return state.completedLessons;
	}
	
	function getLessonCount(state) {
	  return state.lessons.length;
	}
	
	function getLesson(state) {
	  var lesson = state.lessons[state.currentLesson];
	  lesson.index = state.currentLesson;
	  return lesson;
	}
	
	function getSection(state) {
	  return state.lessons[state.currentLesson].sections[state.currentSection];
	}
	
	function getOutput(state) {
	  return state.output;
	}
	
	function getHistory(state) {
	  return state.history;
	}
	
	function getSolved(state) {
	  try {
	    return getSection(state).checkSolved(state) || state.solvedCurrentSection;
	  } catch (e) {
	    return state.solvedCurrentSection;
	  }
	}
	
	function getLessonSolved(state) {
	  return getSolved(state) && getSectionCount(state) === state.currentSection + 1;
	}
	
	function getTurbo(state) {
	  return state.turbo;
	}
	
	function getLessonSelectionActive(state) {
	  return state.lessonSelectionActive;
	}
	
	function getDoneModalActive(state) {
	  return getSolved(state) && !getLessonSolved(state);
	}

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(110)
	__vue_script__ = __webpack_require__(41)
	__vue_template__ = __webpack_require__(131)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.lastCommand = lastCommand;
	exports.workingDirectory = workingDirectory;
	exports.checkType = checkType;
	exports.checkContent = checkContent;
	exports.compose = compose;
	var _ = __webpack_require__(4);
	
	function lastCommand(command, general) {
	  if (general) {
	    return function (state) {
	      return state.emulator.history[state.emulator.history.length - 1].indexOf(command) > -1;
	    };
	  } else {
	    return function (state) {
	      return state.emulator.history[state.emulator.history.length - 1] === command;
	    };
	  }
	}
	
	function workingDirectory(pwd) {
	  return function (state) {
	    return state.emulator.workingDirectory === pwd;
	  };
	}
	
	function checkType(path, type) {
	  return function (state) {
	    if (state.emulator.fileSystem[path]) {
	      return state.emulator.fileSystem[path].type === type;
	    }
	
	    return type === null;
	  };
	}
	
	function checkContent(path, content) {
	  return function (state) {
	    if (state.emulator.fileSystem[path]) {
	      return state.emulator.fileSystem[path].content === content;
	    }
	
	    return false;
	  };
	}
	
	function compose() {
	  for (var _len = arguments.length, functions = Array(_len), _key = 0; _key < _len; _key++) {
	    functions[_key] = arguments[_key];
	  }
	
	  return function (state) {
	    return _.every(functions, function (fn) {
	      return fn(state);
	    });
	  };
	}

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sendCommand = sendCommand;
	exports.reset = reset;
	exports.restartSection = restartSection;
	exports.nextSection = nextSection;
	exports.openLesson = openLesson;
	exports.toggleTurbo = toggleTurbo;
	exports.activateLessonSelection = activateLessonSelection;
	exports.deactivateLessonSelection = deactivateLessonSelection;
	exports.addCompletedLesson = addCompletedLesson;
	function sendCommand(_ref, command) {
	  var dispatch = _ref.dispatch;
	
	  dispatch('SEND_COMMAND', command);
	}
	
	function reset(_ref2) {
	  var dispatch = _ref2.dispatch;
	
	  dispatch('RESET');
	  dispatch('START_SECTION', 0, 0);
	}
	
	function restartSection(_ref3) {
	  var dispatch = _ref3.dispatch,
	      state = _ref3.state;
	
	  dispatch('START_SECTION', state.currentLesson, state.currentSection);
	}
	
	function nextSection(_ref4) {
	  var dispatch = _ref4.dispatch,
	      state = _ref4.state;
	
	  dispatch('START_SECTION', state.currentLesson, state.currentSection + 1);
	}
	
	function openLesson(_ref5, lessonNumber) {
	  var dispatch = _ref5.dispatch;
	
	  dispatch('START_SECTION', lessonNumber, 0);
	  dispatch('DEACTIVATE_LESSON_SELECTION');
	}
	
	function toggleTurbo(_ref6) {
	  var dispatch = _ref6.dispatch;
	
	  dispatch('TOGGLE_TURBO');
	}
	
	function activateLessonSelection(_ref7) {
	  var dispatch = _ref7.dispatch;
	
	  dispatch('ACTIVATE_LESSON_SELECTION');
	}
	
	function deactivateLessonSelection(_ref8) {
	  var dispatch = _ref8.dispatch;
	
	  dispatch('DEACTIVATE_LESSON_SELECTION');
	}
	
	function addCompletedLesson(_ref9, index) {
	  var dispatch = _ref9.dispatch;
	
	  dispatch('ADD_COMPLETED_LESSON', index);
	}

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  clear: function clear(env) {
	    var $0 = document.getElementsByClassName('Step')[0];
	    var lineHeight;
	    try {
	      lineHeight = parseFloat(window.getComputedStyle($0)['line-height'], 10);
	    } catch (e) {
	      lineHeight = 17;
	    }
	    var $terminal = document.getElementsByClassName('Terminal')[0];
	    var height = parseFloat($terminal.offsetHeight, 10);
	    var numberOfLines = parseInt(height / lineHeight, 10);
	    env.output(new Array(numberOfLines).join('\n'));
	    env.exit();
	  },
	  yolo: function yolo(env, args) {
	    var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
	
	    document.body.classList.add('yolo');
	    setTimeout(function () {
	      document.body.classList.remove('yolo');
	      env.exit();
	    }, delay);
	  },
	  sudo: function sudo(store) {
	    return function (env, args) {
	      if (args[0] !== 'reboot') {
	        env.exit(1);
	        return;
	      }
	      store.dispatch('RESET');
	      store.dispatch('START_LESSON', 0, 0);
	      env.exit();
	    };
	  },
	  reboot: function reboot(env) {
	    env.output('reboot: Need to be root');
	    env.exit(1);
	  },
	  noop: function noop(env) {
	    env.exit();
	  },
	  screenShake: function screenShake() {
	    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;
	
	    var terminal = document.getElementById('terminal');
	    terminal.classList.add('shake');
	    var x = _lodash2.default.random(-1.5, 1.5);
	    var y = _lodash2.default.random(-1.5, 1.5);
	    var r = _lodash2.default.random(-2.5, 2.5);
	    terminal.style.transform = 'translate(' + x + '%, ' + y + '%) rotate(' + r + 'deg)';
	
	    setTimeout(function () {
	      terminal.classList.remove('shake');
	      terminal.style.transform = '';
	    }, delay);
	  }
	};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.emulator = exports.mutations = undefined;
	
	var _assign = __webpack_require__(51);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _stringify = __webpack_require__(50);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	exports.saveLocalStorage = saveLocalStorage;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _vue = __webpack_require__(33);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(141);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vueResource = __webpack_require__(140);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _bashEmulator = __webpack_require__(66);
	
	var _bashEmulator2 = _interopRequireDefault(_bashEmulator);
	
	var _utils = __webpack_require__(15);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _getters = __webpack_require__(1);
	
	var getters = _interopRequireWildcard(_getters);
	
	var _lessons = __webpack_require__(36);
	
	var _lessons2 = _interopRequireDefault(_lessons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	_vue2.default.use(_vueResource2.default);
	
	function saveLocalStorage(state) {
	  window.localStorage.state = (0, _stringify2.default)(_lodash2.default.pick(state, ['currentLesson', 'currentSection', 'completedLessons', 'solvedCurrentSection', 'output', 'emulator']));
	}
	
	var initialState = {
	  currentLesson: 0,
	  currentSection: 0,
	  solvedCurrentSection: false,
	  lessons: _lessons2.default,
	  completedLessons: [],
	  output: [],
	  turbo: false,
	  lessonSelectionActive: false,
	  emulator: _lessons2.default[0].sections[0].emulator
	};
	
	var mutations = exports.mutations = {
	  START_SECTION: function START_SECTION(state, lessonNumber, sectionNumber) {
	    state.solvedCurrentSection = false;
	    state.currentLesson = lessonNumber;
	    state.currentSection = sectionNumber;
	
	    state.completedLessons.$remove(lessonNumber);
	
	    if (sectionNumber === 0) {
	      state.output = [];
	      (0, _assign2.default)(emulator.state, state.lessons[state.currentLesson].sections[state.currentSection].emulator);
	      emulator.state.history = [];
	    }
	
	    state.emulator = emulator.state;
	
	    saveLocalStorage(state);
	  },
	  SEND_COMMAND: function SEND_COMMAND(state, command) {
	    state.output.push({ type: 'INPUT', text: command });
	
	    emulator.run(command).then(function (result) {
	      state.output.push({ type: 'OUTPUT', text: result });
	    }, function (err) {
	      state.output.push({ type: 'ERR', text: err });
	    }).then(function () {
	      state.emulator = emulator.state;
	      state.solvedCurrentSection = getters.getSolved(state);
	
	      if (getters.getLessonSolved(state)) {
	        mutations.ADD_COMPLETED_LESSON(state, getters.getLesson(state).index);
	        mutations.ACTIVATE_LESSON_SELECTION(state);
	      }
	
	      saveLocalStorage(state);
	    });
	  },
	  ADD_COMPLETED_LESSON: function ADD_COMPLETED_LESSON(state, index) {
	    state.completedLessons.push(index);
	    state.completedLessons = _lodash2.default.sortBy(_lodash2.default.uniq(state.completedLessons));
	  },
	  RESET: function RESET(state) {
	    _lodash2.default.forIn(_lodash2.default.cloneDeep(initialState), function (value, key) {
	      state[key] = value;
	    });
	
	    emulator.state = state.emulator;
	
	    saveLocalStorage(state);
	  },
	  TOGGLE_TURBO: function TOGGLE_TURBO(state) {
	    state.turbo = !state.turbo;
	  },
	  ACTIVATE_LESSON_SELECTION: function ACTIVATE_LESSON_SELECTION(state) {
	    state.lessonSelectionActive = true;
	  },
	  DEACTIVATE_LESSON_SELECTION: function DEACTIVATE_LESSON_SELECTION(state) {
	    state.lessonSelectionActive = false;
	  }
	};
	
	var vuexState = JSON.parse(window.localStorage.state || '{}');
	
	var store = new _vuex2.default.Store({
	  state: (0, _assign2.default)(_lodash2.default.cloneDeep(initialState), vuexState),
	  mutations: mutations
	});
	
	var emulator = exports.emulator = window.emulator = (0, _bashEmulator2.default)(store.state.emulator);
	
	emulator.commands.clear = utils.clear;
	emulator.commands.yolo = utils.yolo;
	emulator.commands.sudo = utils.sudo(store);
	emulator.commands.reboot = utils.reboot;
	emulator.commands.next = utils.noop;
	
	exports.default = store;

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(103)
	__vue_script__ = __webpack_require__(44)
	__vue_template__ = __webpack_require__(124)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = [__webpack_require__(37), __webpack_require__(38), __webpack_require__(39)];

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(6);
	
	var catExplained = 'The catenate or \'cat\' command is one of the most commonly used, and has three functions: (1.) display text, (2.) combine copies of text files, or (3.) create new ones. We just used the cat command in the previous example to view text from a file. We will use cat frequently, so we will get used to it soon enough.\n\nbasic syntaxes for various operations might look like these.\n\ncat file1\n\ncat file1 > file2\n\ncat file1 | less\n\nWe will learn more about cat as we go along.';
	
	var cdExplained = 'The catenate or \'cat\' command is one of the most commonly used, and has three functions: (1.) display text, (2.) combine copies of text files, or (3.) create new ones. We just used the cat command in the previous example to view text from a file. We will use cat frequently, so we will get used to it soon enough.\n\nbasic syntaxes for various operations might look like these.\n\ncat file1\n\ncat file1 > file2\n\ncat file1 | less\n\nWe will learn more about cat as we go along.';
	
	var filesystemsExplained = 'The file system exists on any computer system, and can be thought of as having a tree structure, with leaves attached to each branch, cascading upwards (or downwards) from the root.\n\nA less abstract example, would be to think of the file system kind of like a library.\n\nIf you can imagine each page of a book as a file, then, each book, it\'s container, would be a folder -- or more specifically, a directory. Each book is organized in a particular location on their respective shelves, and would also function as a directory.\n\nTo illustrate how this would work, we will imagine we want to access page 5 from Moby Dick. We have to find it\'s shelf, it\'s location on the shelf, and turn to page 5. This could be visualized as such.\n\n/ShelfOne/MobyDick/Page5\n\nRemember, computers don\'t have any innate knowledge, and need to be told, and explained every single step.\n\nIn this same way, Computers handle files and directory based on their location from the "root," or the source node--or in our example, the shelf.\n\nMost of us are familiar with this already. We have our Documents, Pictures, Music, and Videos directory usually setup for us went we originally setup our computer.\n\nNormally, we are accustomed to use modern day GUI operating systems, which handle many of our tasks for us via a file manager. And, in many cases, as we will learn, it\'s actually better to take a step back to an archaic time of the command line.\n';
	
	var lsExplained = 'The first command we\'ll explore is the \'ls\' command. The ls command lists the contents of the current directory.\n\nThis is valuable to see what \'we have to work with,\' in our current location. Files and directories are typically displayed, as expected. Additionally, however, there are hidden files. ls will not show these files. To see everything, we need to explain switches (or flages).\n\nWe can change the default behavior of an issued command by applying a switch (or flag) to it. This is done by following it with the minus sign and an appropriate letter. For example, if we type the same ls command, as ls -a, invokes the \'a\' switch. In this case, the \'a\' represents all. So, instead of just listing the default contents of a directory, the ls command now list all files including hidden files, which are no normally displayed.\n\nThere are many flags associated with each command, and we will cover many of the commonly used switches, but not all of them.\n\nThe \'h\' switch is useful, because sometimes we want to list the contents in a more human understandable form. The \'h\' represents human friendly units, instead of normally arcane information that might sometimes be listed.\n\nIt\'s often useful to see deeper information of the contents of the directory, e.g. owner, permissions associated with the content, last time it was accessed, etc. We can get all this detailed information with the \'l\' or long switch in association with the \'ls\' command.\n\nWe might want to list the contents of a directory in a single line, separated by a comma. This can be achieved by using the \'m\' switch.\n\nWhat is really nice, and helpful, is we might want to see the contents of not a single directory, but all the subdirectories within it, as well. We can do this by using the \'R\' switch. If we type \'ls -R\' all the subdirectories will open up, into the list contents of those already visible within the folder.\n\nTry that at your local library to view the contents of all the books on a shelf in an instant!\n\nOther popular switches are \'t\' and \'1\', one not to be mistaken for little l, show the entries by time and forces them into a single column, respectively.\n\nAnother niceity with the usage of switches is that you can use more than one at a time! For example, you can type: \'ls -aR\' to view all the contents of the current working diretory and all it\'s subdirectories. The only limit, is some switches would be counter-productive, so in some cases, their usage may not be allowed with other switches. But, generally, you can use many switches, to however meet your needs.\n\nOk, so we have a pretty good idea of how we can view content now, but how do we move?';
	
	var pwdExplained = '\nSo now that we can navigate around, and list content of our directories, it\'s very easy to get lost. How do I find out where I am?\n\nWe can use the \'pwd\' command, and it will show us the complete path to our current working directory. This is very useful for noting where we are when we work in a particular directory, and want to go there later. Or, simply if we lose track of where we are.\n\nWe should have a pretty good idea of manuveuring around the file system by now, and seeing what files and subdirectories are available, and how to move around them, up and down, and even be able to always find out where we are. Also, we have learned about switches, and how they alter the normal behavior of commands so that they can provide other features, that the normal command alone would not offer.\n\nBut, how can we do other stuff we\'re used to? In the next lesson we\'ll have a look at file manipulation, such that, we can move, copy, delete, create files and directories.\n';
	
	var arrowKeysExplained = '\nUP and DOWN arrows on your keyboard can be used to show your command history. If you push the up arrow, you will cycle, backwards, to all the commands you have entered. It\'s a common tactic used by hackers, who gain access to your computer, to simply cycle back through the commands you have entered.\n\nIf you push the DOWN arrow, after already going back, it will cycle forward through the commands you have entered.\n\nAlternatively, you could also type the history command, and it will show all the commands you have entered, all saved in the .bash_history file. You\'ll notice there is a row number on the left of each command, which denotes the incremental count of commands saved.\n';
	
	var emulator = {
	  history: [],
	  workingDirectory: '/home/user',
	  user: 'user',
	  fileSystem: {
	    '/': {
	      type: 'dir',
	      modified: Date.now()
	    },
	    '/home': {
	      type: 'dir',
	      modified: Date.now()
	    },
	    '/home/user': {
	      type: 'dir',
	      modified: Date.now()
	    },
	    '/home/user/Desktop': {
	      type: 'dir',
	      modified: Date.now()
	    },
	    '/home/user/Desktop/hello.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: 'Hello! This file is really empty!'
	    },
	    '/home/user/Documents': {
	      type: 'dir',
	      modified: Date.now()
	    },
	    '/home/user/Documents/cat_explained.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: catExplained
	    },
	    '/home/user/Documents/cd_explained.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: cdExplained
	    },
	    '/home/user/Documents/filesystems_explained.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: filesystemsExplained
	    },
	    '/home/user/Documents/Homework': {
	      type: 'dir',
	      modified: Date.now()
	    },
	    '/home/user/Documents/Homework/labOne.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: 'TODO'
	    },
	    '/home/user/Downloads': {
	      type: 'dir',
	      modified: Date.now()
	    },
	    '/home/user/Music': {
	      type: 'dir',
	      modified: Date.now()
	    },
	    '/home/user/Pictures': {
	      type: 'dir',
	      modified: Date.now()
	    },
	    '/home/user/Videos': {
	      type: 'dir',
	      modified: Date.now()
	    },
	    '/home/user/ls_explained.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: lsExplained
	    },
	    '/home/user/pwd_explained.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: pwdExplained
	    },
	    '/home/user/arrowKeys_explained.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: arrowKeysExplained
	    },
	    '/home/user/.hidden.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: 'hidden file is empty'
	    }
	  }
	};
	
	module.exports = {
	  title: 'Navigation',
	  sections: [{
	    task: 'Hello there!\n\nThis is the TryBash command line.\nBefore we can do anything useful within the command line, we have to get acclimated with moving around the file system.\n\nType <code>ls</code> to list files and folders.',
	    emulator: emulator,
	    checkSolved: utils.lastCommand('ls')
	  }, {
	    task: 'Throughout this tutorial, you\'ll find files named like "ls_explained.txt". These are help files that we recommend all new users to read. They can be skipped by those more experienced with the command line.\n\nTry using <code>cat ls_explained.txt</code> to read the more about the <code>ls</code> command.',
	    emulator: emulator,
	    checkSolved: utils.lastCommand('cat ls_explained.txt')
	  }, {
	    task: 'Wow, too much text on the screen. It\'s possible, from time to time, to find yourself with too much clutter in your console. To clear it, you can just use the <code>clear</code> command.\n\nType <code>clear</code> to clear the console.',
	    emulator: emulator,
	    checkSolved: utils.lastCommand('clear')
	  }, {
	    task: 'We have now used the <code>cat</code> command, which we will need again later in this tutorial.\nNext, we learn about "switches" or "flags" of commands. These appear as the command itself, followed by a hyphen and one or more trailing letters.\n\nType <code>ls -a</code> to show even the hidden files!',
	    emulator: emulator,
	    checkSolved: utils.lastCommand('ls -a')
	  }, {
	    task: 'We will use various switches throughout the tutorial, and you\'ll see how useful they are to enhance the default behavior of commands. There are far more than we will cover, but you\'ll learn the basics.\n\nType <code>ls -l</code> to show a directory listing with additional information.',
	    emulator: emulator,
	    checkSolved: utils.lastCommand('ls -l')
	  }, {
	    task: 'Ok, so we have listed items in our directory, but what if our files are somewhere else? No problem. We can just move there. As you have noticed, by using the <code>ls</code> command, it\'s easy to tell which items are files and which are directories.\n\nType <code>cd Documents</code> to <em>change</em> to the "Documents" folder.',
	    emulator: emulator,
	    checkSolved: utils.workingDirectory('/home/user/Documents')
	  }, {
	    task: 'We are now in another folder named "Documents". List its contents with one of the commands you have learned so far.',
	    emulator: emulator,
	    checkSolved: utils.lastCommand('ls', true)
	  }, {
	    task: 'Great! <code>cd</code> can be used to change the working directory to any location. If you know the full path, you can just type it in.\n\nOr you can also simply change one step back by using <code>cd ..</code> - Try it!',
	    emulator: emulator,
	    checkSolved: utils.lastCommand('cd ..')
	  }, {
	    task: 'Ok, now we\'re really making progress. We know how to list directories, and navigate around. Let\'s practice some more.\n\nGo to <code>/home/user/Documents/Homework/</code>',
	    emulator: emulator,
	    checkSolved: utils.workingDirectory('/home/user/Documents/Homework')
	  }, {
	    task: 'Now, lets move to another location.\n\nGo to <code>/home/user/Desktop</code>',
	    emulator: emulator,
	    checkSolved: utils.workingDirectory('/home/user/Desktop')
	  }, {
	    task: 'All this moving around could make one\'s head spin. How to figure out where we are within the entire file system?\n\nEasy! You can use the <em>print working directory</em> command: <code>pwd</code>.',
	    emulator: emulator,
	    checkSolved: utils.lastCommand('pwd')
	  }, {
	    task: 'This concludes our first lesson!\nFeel free to read the "filesystems_explained.txt" (using <code>cat</code>) in the "Documents" folder, if you need help conceptualizing directory structures.\nWe will learn about moving and copying files in the next lesson.\n\nType <code>next</code> when you are done! Or look around a bit more, if you like.',
	    emulator: emulator,
	    checkSolved: utils.lastCommand('next')
	  }]
	};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(6);
	
	var catExplained = 'The catenate or \'cat\' command is one of the most commonly used, and has three functions: (1.) display text, (2.) combine copies of text files, or (3.) create new ones. We just used the cat command in the previous example to view text from a file. We will use cat frequently, so we will get used to it soon enough.\n\nbasic syntaxes for various operations might look like these.\n\ncat file1\n\ncat file1 > file2\n\ncat file1 | less\n\nWe will learn more about cat as we go along.';
	
	var cdExplained = 'The catenate or \'cat\' command is one of the most commonly used, and has three functions: (1.) display text, (2.) combine copies of text files, or (3.) create new ones. We just used the cat command in the previous example to view text from a file. We will use cat frequently, so we will get used to it soon enough.\n\nbasic syntaxes for various operations might look like these.\n\ncat file1\n\ncat file1 > file2\n\ncat file1 | less\n\nWe will learn more about cat as we go along.';
	
	var filesystemsExplained = 'The file system exists on any computer system, and can be thought of as having a tree structure, with leaves attached to each branch, cascading upwards (or downwards) from the root.\n\nA less abstract example, would be to think of the file system kind of like a library.\n\nIf you can imagine each page of a book as a file, then, each book, it\'s container, would be a folder -- or more specifically, a directory. Each book is organized in a particular location on their respective shelves, and would also function as a directory.\n\nTo illustrate how this would work, we will imagine we want to access page 5 from Moby Dick. We have to find it\'s shelf, it\'s location on the shelf, and turn to page 5. This could be visualized as such.\n\n/ShelfOne/MobyDick/Page5\n\nRemember, computers don\'t have any innate knowledge, and need to be told, and explained every single step.\n\nIn this same way, Computers handle files and directory based on their location from the "root," or the source node--or in our example, the shelf.\n\nMost of us are familiar with this already. We have our Documents, Pictures, Music, and Videos directory usually setup for us went we originally setup our computer.\n\nNormally, we are accustomed to use modern day GUI operating systems, which handle many of our tasks for us via a file manager. And, in many cases, as we will learn, it\'s actually better to take a step back to an archaic time of the command line.\n';
	
	var lsExplained = 'The first command we\'ll explore is the \'ls\' command. The ls command lists the contents of the current directory.\n\nThis is valuable to see what \'we have to work with,\' in our current location. Files and directories are typically displayed, as expected. Additionally, however, there are hidden files. ls will not show these files. To see everything, we need to explain switches (or flages).\n\nWe can change the default behavior of an issued command by applying a switch (or flag) to it. This is done by following it with the minus sign and an appropriate letter. For example, if we type the same ls command, as ls -a, invokes the \'a\' switch. In this case, the \'a\' represents all. So, instead of just listing the default contents of a directory, the ls command now list all files including hidden files, which are no normally displayed.\n\nThere are many flags associated with each command, and we will cover many of the commonly used switches, but not all of them.\n\nThe \'h\' switch is useful, because sometimes we want to list the contents in a more human understandable form. The \'h\' represents human friendly units, instead of normally arcane information that might sometimes be listed.\n\nIt\'s often useful to see deeper information of the contents of the directory, e.g. owner, permissions associated with the content, last time it was accessed, etc. We can get all this detailed information with the \'l\' or long switch in association with the \'ls\' command.\n\nWe might want to list the contents of a directory in a single line, separated by a comma. This can be achieved by using the \'m\' switch.\n\nWhat is really nice, and helpful, is we might want to see the contents of not a single directory, but all the subdirectories within it, as well. We can do this by using the \'R\' switch. If we type \'ls -R\' all the subdirectories will open up, into the list contents of those already visible within the folder.\n\nTry that at your local library to view the contents of all the books on a shelf in an instant!\n\nOther popular switches are \'t\' and \'1\', one not to be mistaken for little l, show the entries by time and forces them into a single column, respectively.\n\nAnother niceity with the usage of switches is that you can use more than one at a time! For example, you can type: \'ls -aR\' to view all the contents of the current working diretory and all it\'s subdirectories. The only limit, is some switches would be counter-productive, so in some cases, their usage may not be allowed with other switches. But, generally, you can use many switches, to however meet your needs.\n\nOk, so we have a pretty good idea of how we can view content now, but how do move?';
	
	var pwdExplained = 'So now that we can navigate around, and list content of our directories, it\'s very easy to get lost. How do I find out where I am?\n\nWe can use the \'pwd\' command, and it will show us the complete path to our current working directory. This is very useful for noting where we are when we work in a particular directory, and want to go there later. Or, simply if we lose track of where we are.\n\nWe should have a pretty good idea of manuveuring around the file system by now, and seeing what files and subdirectories are available, and how to move around them, up and down, and even be able to always find out where we are. Also, we have learned about switches, and how they alter the normal behavior of commands so that they can provide other features, that the normal command alone would not offer.\n\nBut, how can we do other stuff we\'re used to? In the next lesson we\'ll have a look at file manipulation, such that, we can move, copy, delete, create files and directories.\n';
	
	var emulator = {
	  history: [],
	  workingDirectory: '/home/user',
	  user: 'user',
	  fileSystem: {
	    '/': {
	      type: 'dir',
	      modified: Date.now()
	    },
	    '/home': {
	      type: 'dir',
	      modified: Date.now()
	    },
	    '/home/user': {
	      type: 'dir',
	      modified: Date.now()
	    },
	    '/home/user/Desktop': {
	      type: 'dir',
	      modified: Date.now()
	    },
	    '/home/user/Documents': {
	      type: 'dir',
	      modified: Date.now()
	    },
	    '/home/user/Documents/cat_explained.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: catExplained
	    },
	    '/home/user/Documents/cd_explained.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: cdExplained
	    },
	    '/home/user/Documents/filesystems_explained.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: filesystemsExplained
	    },
	    '/home/user/Documents/Homework': {
	      type: 'dir',
	      modified: Date.now()
	    },
	    '/home/user/Documents/Homework/labOne.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: 'TODO'
	    },
	    '/home/user/Downloads': {
	      type: 'dir',
	      modified: Date.now()
	    },
	    '/home/user/Music': {
	      type: 'dir',
	      modified: Date.now()
	    },
	    '/home/user/Pictures': {
	      type: 'dir',
	      modified: Date.now()
	    },
	    '/home/user/Videos': {
	      type: 'dir',
	      modified: Date.now()
	    },
	    '/home/user/ls_explained.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: lsExplained
	    },
	    '/home/user/pwd_explained.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: pwdExplained
	    },
	    '/home/user/.hidden.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: 'hidden file is empty'
	    },
	    '/home/user/homework1.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: 'All work and no play'
	    },
	    '/home/user/homework2.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: 'Makes bash a dull boy'
	    },
	    '/home/user/homework3.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: 'Homework is literally the best'
	    },
	    '/home/user/dolly.sheep': {
	      type: 'file',
	      modified: Date.now(),
	      content: 'Baa Baa. Baa!'
	    },
	    '/home/user/a.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: 'A!'
	    },
	    '/home/user/b.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: 'I have a bad feeling about this.'
	    },
	    '/home/user/c.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: 'C!'
	    }
	  }
	};
	
	module.exports = {
	  title: 'Copying and Moving',
	  sections: [{
	    task: 'This lesson we\'re going to learn some very important actions: copying files and moving files.\nUse a command you have learned in a previous lesson to list what\'s in the current directory to get started!\n\n<small>Hint: Use <code>ls</code>.</small>',
	    emulator: emulator,
	    checkSolved: utils.lastCommand('ls', true)
	  }, {
	    task: 'What a mess. Let\'s move the "homework1.txt" into the "Documents" folder, to clean up a little.\n\nType <code>mv homework1.txt Documents/homework1.txt</code>',
	    emulator: emulator,
	    checkSolved: utils.checkType('/home/user/Documents/homework1.txt', 'file')
	  }, {
	    task: 'The move syntax is pretty simple, <code>mv <em>source destination</em></code>.\nBut you can even move several files at once! Time to clean up the other homework files:\n\n<code>mv homework2.txt homework3.txt Documents</code>',
	    emulator: emulator,
	    checkSolved: utils.compose(utils.checkType('/home/user/Documents/homework2.txt', 'file'), utils.checkType('/home/user/Documents/homework3.txt', 'file'))
	  }, {
	    task: 'Now, lets move on to copying. This won\'t be hard, it works almost the same way as moving.\n\nCopy the <code>dolly.sheep</code> file using <code>cp dolly.sheep clone.sheep</code>',
	    emulator: emulator,
	    checkSolved: utils.checkType('/home/user/clone.sheep', 'file')
	  }, {
	    task: 'Copying files, like <code>mv</code> and many other commands, allow adressing multiple files at once!\n\nCopy Dolly and her clone to the "Documents" folder with <code>cp dolly.sheep clone.sheep Documents</code>',
	    emulator: emulator,
	    checkSolved: utils.compose(utils.checkType('/home/user/dolly.sheep', 'file'), utils.checkType('/home/user/clone.sheep', 'file'), utils.checkType('/home/user/Documents/dolly.sheep', 'file'), utils.checkType('/home/user/Documents/clone.sheep', 'file'))
	  }, {
	    task: 'If you\'re not careful, you can overwrite files with <code>mv</code>, if the target file already exists.\n\nLook at the files in the current directory.\nThen try moving <code>a.txt</code> to <code>b.txt</code>.',
	    emulator: emulator,
	    checkSolved: utils.compose(utils.checkType('/home/user/a.txt', null), utils.checkContent('/home/user/b.txt', 'A!'))
	  }, {
	    task: 'Oops!\nIf you type <code>ls</code> again you can see that "a.txt" is gone. With <code>cat b.txt</code> you can see that the content has changed!\nYou can always play it safe by using the <code>mv -n</code> switch, which does not overwrite existing files.\n\nTry taking <code>b.txt</code> to overwrite <code>c.txt</code>, but this time, use the <code>-n</code> flag to keep your files safe.',
	    emulator: emulator,
	    checkSolved: utils.compose(utils.lastCommand('mv -n b.txt c.txt', false), utils.checkType('/home/user/b.txt', 'file'), utils.checkContent('/home/user/c.txt', 'C!'))
	  }, {
	    task: '\nGood! This time no files have been changed.\n\nYou can even copy a whole directory somewhere else by using <code>cp -r</code>.\n\nUse it to copy your <code>Documents</code> folder and all its contents into the <code>MySheeps</code> folder.',
	    emulator: emulator,
	    checkSolved: utils.compose(utils.checkType('/home/user/MySheeps', 'dir'), utils.checkType('/home/user/Documents', 'dir'))
	  }, {
	    task: 'This concludes our second lesson. You should now be comfortable navigating the file system, copying files and moving files around.\n\nType <code>next</code> and you are ready!',
	    emulator: emulator,
	    checkSolved: utils.lastCommand('next')
	  }]
	};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(6);
	
	var catExplained = 'The catenate or \'cat\' command is one of the most commonly used, and has three functions: (1.) display text, (2.) combine copies of text files, or (3.) create new ones. We just used the cat command in the previous example to view text from a file. We will use cat frequently, so we will get used to it soon enough.\n\nbasic syntaxes for various operations might look like these.\n\ncat file1\n\ncat file1 > file2\n\ncat file1 | less\n\nWe will learn more about cat as we go along.';
	
	var cdExplained = 'The catenate or \'cat\' command is one of the most commonly used, and has three functions: (1.) display text, (2.) combine copies of text files, or (3.) create new ones. We just used the cat command in the previous example to view text from a file. We will use cat frequently, so we will get used to it soon enough.\n\nbasic syntaxes for various operations might look like these.\n\ncat file1\n\ncat file1 > file2\n\ncat file1 | less\n\nWe will learn more about cat as we go along.';
	
	var filesystemsExplained = 'The file system exists on any computer system, and can be thought of as having a tree structure, with leaves attached to each branch, cascading upwards (or downwards) from the root.\n\nA less abstract example, would be to think of the file system kind of like a library.\n\nIf you can imagine each page of a book as a file, then, each book, it\'s container, would be a folder -- or more specifically, a directory. Each book is organized in a particular location on their respective shelves, and would also function as a directory.\n\nTo illustrate how this would work, we will imagine we want to access page 5 from Moby Dick. We have to find it\'s shelf, it\'s location on the shelf, and turn to page 5. This could be visualized as such.\n\n/ShelfOne/MobyDick/Page5\n\nRemember, computers don\'t have any innate knowledge, and need to be told, and explained every single step.\n\nIn this same way, Computers handle files and directory based on their location from the "root," or the source node--or in our example, the shelf.\n\nMost of us are familiar with this already. We have our Documents, Pictures, Music, and Videos directory usually setup for us went we originally setup our computer.\n\nNormally, we are accustomed to use modern day GUI operating systems, which handle many of our tasks for us via a file manager. And, in many cases, as we will learn, it\'s actually better to take a step back to an archaic time of the command line.';
	
	var lsExplained = 'The first command we\'ll explore is the \'ls\' command. The ls command lists the contents of the current directory.\n\nThis is valuable to see what \'we have to work with,\' in our current location. Files and directories are typically displayed, as expected. Additionally, however, there are hidden files. ls will not show these files. To see everything, we need to explain switches (or flages).\n\nWe can change the default behavior of an issued command by applying a switch (or flag) to it. This is done by following it with the minus sign and an appropriate letter. For example, if we type the same ls command, as ls -a, invokes the \'a\' switch. In this case, the \'a\' represents all. So, instead of just listing the default contents of a directory, the ls command now list all files including hidden files, which are no normally displayed.\n\nThere are many flags associated with each command, and we will cover many of the commonly used switches, but not all of them.\n\nThe \'h\' switch is useful, because sometimes we want to list the contents in a more human understandable form. The \'h\' represents human friendly units, instead of normally arcane information that might sometimes be listed.\n\nIt\'s often useful to see deeper information of the contents of the directory, e.g. owner, permissions associated with the content, last time it was accessed, etc. We can get all this detailed information with the \'l\' or long switch in association with the \'ls\' command.\n\nWe might want to list the contents of a directory in a single line, separated by a comma. This can be achieved by using the \'m\' switch.\n\nWhat is really nice, and helpful, is we might want to see the contents of not a single directory, but all the subdirectories within it, as well. We can do this by using the \'R\' switch. If we type \'ls -R\' all the subdirectories will open up, into the list contents of those already visible within the folder.\n\nTry that at your local library to view the contents of all the books on a shelf in an instant!\n\nOther popular switches are \'t\' and \'1\', one not to be mistaken for little l, show the entries by time and forces them into a single column, respectively.\n\nAnother niceity with the usage of switches is that you can use more than one at a time! For example, you can type: \'ls -aR\' to view all the contents of the current working diretory and all it\'s subdirectories. The only limit, is some switches would be counter-productive, so in some cases, their usage may not be allowed with other switches. But, generally, you can use many switches, to however meet your needs.\n\nOk, so we have a pretty good idea of how we can view content now, but how do move?';
	
	var pwdExplained = 'So now that we can navigate around, and list content of our directories, it\'s very easy to get lost. How do I find out where I am?\n\nWe can use the \'pwd\' command, and it will show us the complete path to our current working directory. This is very useful for noting where we are when we work in a particular directory, and want to go there later. Or, simply if we lose track of where we are.\n\nWe should have a pretty good idea of manuveuring around the file system by now, and seeing what files and subdirectories are available, and how to move around them, up and down, and even be able to always find out where we are. Also, we have learned about switches, and how they alter the normal behavior of commands so that they can provide other features, that the normal command alone would not offer.\n\nBut, how can we do other stuff we\'re used to? In the next lesson we\'ll have a look at file manipulation, such that, we can move, copy, delete, create files and directories.';
	
	var mkdirExplained = 'The mkdir command create directories. It stands for "MaKe DIRectory." It is the fundamental computer operation of creating a folder, and used to create storage directories for our different types of data.\n\nAn important component of directories has to do with ownership, but is not within the scope of this tutorial. That will be developed in the future. Stay tuned.';
	
	var rmExplained = 'Here we will discuss both the rm and rmdir commands, because of their similarity and overlap.\n\nThe rm command is used for removing files. Be careful with it\'s use, there is no undo command. When you use the rm filename, you delete filename without question. Theoretically, it would be possible to recover the information, via additional software -- if done relatively immediately after the deletion.\n\nJust like with modern GUIs, the rm command \'unlinks\' the file, meaning it is not accessible anymore by the system. However, the file is not technically \'deleted.\' To completely remove a file, you would want to use the shred command, but that is outside the scope of this tutorial.\n\nAlso, the rm command by default does not work on directories. To delete directories, you would need to use the recursive switch:\n\nrm -R directory\n\nAnother alternative to delete a directory would be to use the rmdir command, which is specifically designed to delete directories.\n\nSo, in summation, you can delete a file by using the rm command, and delete directories by using rm -R dirName or rmdir dirName.';
	
	var touchExplained = 'The touch command is a very commonly used command for creating empty folders.\n\nThe command changes the timestamps of file(s), so if the file already exists, the timestamp data, like when it was last accessed is updated to the current time. For the average computer user, normally, that is not of particularly great importance, but for some administrator or related purposes, it is very important.\n\nAdditionally, what is a bonus feature of this command, if the file does not exist, it is created! The file of course will be empty, but you now have a container to throw stuff into. Many other bash commands only work if something goes into a file. So, often times, you\'ll need to just create an empty file to throw stuff into. Touch facilities this, by creating a file, as such:\n\ntouch testFile\n\nThe testFile is created!\n\nOf course, if you don\'t want to create a bunch of empty files, you could use the -c switch, as such:\n\ntouch -c testFile\n\nThis updates the timestamp on testFile, but if it does not exist, the file is not created.';
	
	var emulator = {
	  history: [],
	  workingDirectory: '/home/user',
	  user: 'user',
	  fileSystem: {
	    '/': {
	      type: 'dir',
	      modified: Date.now()
	    },
	    '/home': {
	      type: 'dir',
	      modified: Date.now()
	    },
	    '/home/user': {
	      type: 'dir',
	      modified: Date.now()
	    },
	    '/home/user/Desktop': {
	      type: 'dir',
	      modified: Date.now()
	    },
	    '/home/user/Documents': {
	      type: 'dir',
	      modified: Date.now()
	    },
	    '/home/user/Documents/cat_explained.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: catExplained
	    },
	    '/home/user/Documents/cd_explained.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: cdExplained
	    },
	    '/home/user/Documents/filesystems_explained.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: filesystemsExplained
	    },
	    '/home/user/Documents/mkdirExplained.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: mkdirExplained
	    },
	    '/home/user/Documents/rmExplained.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: rmExplained
	    },
	    '/home/user/Documents/touchExplained.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: touchExplained
	    },
	    '/home/user/Documents/Homework': {
	      type: 'dir',
	      modified: Date.now()
	    },
	    '/home/user/Documents/Homework/labOne.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: 'TODO'
	    },
	    '/home/user/Downloads': {
	      type: 'dir',
	      modified: Date.now()
	    },
	    '/home/user/Music': {
	      type: 'dir',
	      modified: Date.now()
	    },
	    '/home/user/Pictures': {
	      type: 'dir',
	      modified: Date.now()
	    },
	    '/home/user/Videos': {
	      type: 'dir',
	      modified: Date.now()
	    },
	    '/home/user/ls_explained.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: lsExplained
	    },
	    '/home/user/pwd_explained.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: pwdExplained
	    },
	    '/home/user/.hidden.txt': {
	      type: 'file',
	      modified: Date.now(),
	      content: 'hidden file is empty'
	    }
	  }
	};
	
	module.exports = {
	  title: 'Creating and Removing of Files and Directories',
	  sections: [{
	    task: 'We\'ve learned how to use various commands so far \u2013 <code>ls</code> <code>pwd</code> <code>cd</code> <code>cp</code> <code>mv</code> \u2013 to name a few.\nNow, lets learn how to create directories.\n\nTo create your first folder try typing <code>mkdir testFolder</code>.',
	    emulator: emulator,
	    checkSolved: utils.checkType('/home/user/testFolder', 'dir')
	  }, {
	    task: 'Use a command you learned in a previous lesson to <em>change</em> into the <code>testFolder</code> directory, and we continue there.',
	    emulator: emulator,
	    checkSolved: utils.workingDirectory('/home/user/testFolder')
	  }, {
	    task: 'Now, let\'s create a new file at our current location.\nThere are many ways to create a file, but one simple way is to use the <code>touch</code> command.\nNormally, <code>touch</code> updates timestamps on a file, but if the file doesn\'t exist, an empty file is created with the provided name.\n\nCreate a file called "test1.txt" in "testFolder" by typing <code>touch test1.txt</code>.',
	    emulator: emulator,
	    checkSolved: utils.checkType('/home/user/testFolder/test1.txt', 'file')
	  }, {
	    task: 'Now we have a new, empty file. But we decide that we don\'t need the file anymore.\n\nWe can delete it with the <code>rm</code> command.\n\nTry removing the <code>test1.txt</code> file!',
	    emulator: emulator,
	    checkSolved: utils.checkType('/home/user/testFolder/test1.txt', null)
	  }, {
	    task: 'That was simple enough.\nUse a command from a previous lesson to list the contents of the directory you are currently in.',
	    emulator: emulator,
	    checkSolved: utils.lastCommand('ls', true)
	  }, {
	    task: 'Let\'s return to the command we started this lesson with: <code>mkdir</code>.\nWe can use it to quickly create multiple directories in one swing.\n\nCreate three directories inside the <code>testFolder</code> for items we want to store over the next three weeks by typing: <code>mkdir week1 week2 week3</code>.',
	    emulator: emulator,
	    checkSolved: utils.compose(utils.checkType('/home/user/testFolder/week1', 'dir'), utils.checkType('/home/user/testFolder/week2', 'dir'), utils.checkType('/home/user/testFolder/week3', 'dir'))
	  }, {
	    task: 'We, however, decide we only need two weeks, so let\'s delete "week3".\nThere are two ways to do this. First, we can use the <code>rm</code> command with the <code>-R</code> flag to make it "recursive".\nThis means the command can not only delete one file, but instead it can delete a folder with all its content.\n\nTry this with <code>rm -R week3</code>.',
	    emulator: emulator,
	    checkSolved: utils.compose(utils.checkType('/home/user/testFolder/week1', 'dir'), utils.checkType('/home/user/testFolder/week2', 'dir'), utils.checkType('/home/user/testFolder/week3', null))
	  }, {
	    task: 'As always within the command line, there are many ways to do tasks. It\'s always best to do what you feel comfortable with.  That\'s why you will learn another way to delete a directory!\nThis time, use the <code>rmdir</code> command to delete the directory <code>week2</code>.\n\nUse <code>rmdir</code> the same way you used <code>rm -R</code>.',
	    emulator: emulator,
	    checkSolved: utils.checkType('/home/user/testFolder/week2', null)
	  }, {
	    task: 'We now have learned how to quickly create files with the <code>touch</code> command, and how to create directories with the <code>mkdir</code> command.\n\nType <code>next</code> when you are ready to finish this lesson.',
	    emulator: emulator,
	    checkSolved: utils.lastCommand('next')
	  }]
	};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Terminal = __webpack_require__(139);
	
	var _Terminal2 = _interopRequireDefault(_Terminal);
	
	var _Progress = __webpack_require__(135);
	
	var _Progress2 = _interopRequireDefault(_Progress);
	
	var _Task = __webpack_require__(138);
	
	var _Task2 = _interopRequireDefault(_Task);
	
	var _Button = __webpack_require__(5);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Done = __webpack_require__(133);
	
	var _Done2 = _interopRequireDefault(_Done);
	
	var _LessonSelection = __webpack_require__(134);
	
	var _LessonSelection2 = _interopRequireDefault(_LessonSelection);
	
	var _store = __webpack_require__(16);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    'tb-terminal': _Terminal2.default,
	    'tb-progress': _Progress2.default,
	    'tb-task': _Task2.default,
	    'tb-button': _Button2.default,
	    'tb-done': _Done2.default,
	    'tb-lesson-selection': _LessonSelection2.default
	  },
	
	  store: _store2.default
	};

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  props: ['color']
	};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Button = __webpack_require__(5);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Modal = __webpack_require__(32);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _getters = __webpack_require__(1);
	
	var _actions = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  components: {
	    'tb-button': _Button2.default,
	    'tb-modal': _Modal2.default
	  },
	
	  vuex: {
	    actions: {
	      nextSection: _actions.nextSection,
	      restartSection: _actions.restartSection
	    },
	    getters: {
	      active: _getters.getDoneModalActive
	    }
	  },
	
	  data: function data() {
	    return {
	      praises: ['Done!', 'Nice Work!', 'Wow!', 'Amazing!', 'Incredible!', 'Awesome!', 'Nice Job!', 'Excellent!', 'Great!'],
	      praiseIndex: 0
	    };
	  },
	
	
	  watch: {
	    active: function active(val) {
	      if (val) {
	        this.$els.next.focus();
	        this.newPraise();
	      }
	    }
	  },
	
	  methods: {
	    newPraise: function newPraise() {
	      this.praiseIndex = _lodash2.default.random(this.praises.length - 1);
	    }
	  }
	};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Modal = __webpack_require__(32);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Button = __webpack_require__(5);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _getters = __webpack_require__(1);
	
	var _actions = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  vuex: {
	    actions: {
	      reset: _actions.reset,
	      openLesson: _actions.openLesson,
	      deactivateLessonSelection: _actions.deactivateLessonSelection
	    },
	
	    getters: {
	      lessons: _getters.getLessons,
	      selectionActive: _getters.getLessonSelectionActive
	    }
	  },
	
	  components: {
	    'tb-modal': _Modal2.default,
	    'tb-button': _Button2.default
	  },
	
	  methods: {
	    getColor: function getColor(lesson) {
	      return lesson.active ? 'yellow' : 'green';
	    },
	    getButtontext: function getButtontext(lesson) {
	      var text = 'Start';
	      if (lesson.active) text = 'Continue';
	      if (lesson.done) text = 'Play Again';
	      return text;
	    }
	  }
	};

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  props: ['active']
	};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ProgressBlocks = __webpack_require__(137);
	
	var _ProgressBlocks2 = _interopRequireDefault(_ProgressBlocks);
	
	var _ProgressBar = __webpack_require__(136);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	var _getters = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    'tb-progress-blocks': _ProgressBlocks2.default,
	    'tb-progress-bar': _ProgressBar2.default
	  },
	
	  vuex: {
	    getters: {
	      currentSection: _getters.getCompletedSectionCount,
	      maxSection: _getters.getSectionCount,
	      currentLesson: _getters.getCompletedCount,
	      maxLesson: _getters.getLessonCount
	    }
	  }
	};

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['current', 'max'],
	
	  computed: {
	    fillWidth: function fillWidth() {
	      return this.current * 100 / this.max + '%';
	    }
	  }
	};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _getters = __webpack_require__(1);
	
	module.exports = {
	  vuex: {
	    getters: {
	      lessons: _getters.getLessons
	    }
	  }
	};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _getters = __webpack_require__(1);
	
	module.exports = {
	  vuex: {
	    getters: {
	      section: _getters.getSection
	    }
	  },
	
	  data: function data() {
	    return {
	      sections: ['', this.section]
	    };
	  },
	
	
	  watch: {
	    section: function section(val) {
	      this.sections.shift();
	      this.sections.push(val);
	    }
	  }
	};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _defineProperty2 = __webpack_require__(53);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _methods;
	
	var _Button = __webpack_require__(5);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _getters = __webpack_require__(1);
	
	var _actions = __webpack_require__(7);
	
	var _store = __webpack_require__(16);
	
	var _utils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TAB = 9;
	var ENTER = 13;
	var UP = 38;
	var DOWN = 40;
	
	module.exports = {
	  data: function data() {
	    return { command: '' };
	  },
	
	
	  vuex: {
	    actions: {
	      sendCommand: _actions.sendCommand,
	      toggleTurbo: _actions.toggleTurbo,
	      activateLessonSelection: _actions.activateLessonSelection
	    },
	
	    getters: {
	      output: _getters.getOutput,
	      history: _getters.getHistory,
	      turbo: _getters.getTurbo,
	      doneModalActive: _getters.getDoneModalActive,
	      lessonSelectionActive: _getters.getLessonSelectionActive
	    }
	  },
	
	  components: {
	    'tb-button': _Button2.default
	  },
	
	  watch: {
	    output: function output() {
	      this.scrollBottom();
	    },
	    lessonSelectionActive: function lessonSelectionActive(val) {
	      if (val === false) this.focusInput();
	    },
	    doneModalActive: function doneModalActive(val) {
	      if (val === false) this.focusInput();
	    }
	  },
	
	  ready: function ready() {
	    this.focusInput();
	    this.scrollBottom();
	  },
	
	
	  methods: (_methods = {
	    submit: function submit(event) {
	      event.preventDefault();
	      if (!this.command.length) return;
	      this.sendCommand(this.command);
	      this.command = '';
	    },
	    scrollBottom: function scrollBottom() {
	      this.$els.terminal.scrollTop = this.$els.terminal.scrollHeight;
	    },
	    focusInput: function focusInput() {
	      this.$els.input.focus();
	    },
	
	
	    screenShake: _utils.screenShake
	
	  }, (0, _defineProperty3.default)(_methods, UP, _store.emulator.completeUp), (0, _defineProperty3.default)(_methods, DOWN, _store.emulator.completeDown), (0, _defineProperty3.default)(_methods, 'complete', function complete(direction) {
	    var _this = this;
	
	    var input = this.$els.input;
	    var completeFunction = this[direction];
	    if (!completeFunction) return;
	    var cursorPosition = input.selectionStart;
	    var beforeCursor = input.value.slice(0, cursorPosition);
	    completeFunction(beforeCursor).then(function (completion) {
	      if (completion) {
	        _this.command = completion;
	        input.value = completion;
	        input.setSelectionRange(cursorPosition, cursorPosition);
	      }
	    });
	  }), (0, _defineProperty3.default)(_methods, 'keydown', function keydown(e) {
	    if (this.turbo) this.screenShake();
	
	    if (e.which === TAB) {
	      e.preventDefault();
	    }
	
	    if (e.which === ENTER) {
	      this.submit(e);
	    }
	
	    if (e.altKey || e.metaKey || e.shiftKey || e.ctrlKey) {
	      return;
	    }
	
	    if (e.which === UP || e.which === DOWN) {
	      e.preventDefault();
	      this.complete(e.which);
	    }
	  }), _methods)
	};

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 102 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 103 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 105 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 107 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjExMDhweCIgaGVpZ2h0PSIyNTlweCIgdmlld0JveD0iMCAwIDExMDggMjU5IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCAzLjguMyAoMjk4MDIpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPkdyb3VwPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkFydGJvYXJkLTItQ29weS0zIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTI5LjAwMDAwMCwgLTg0LjAwMDAwMCkiIGZpbGw9IiM3NkI5MDAiPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyOS4wMDAwMDAsIDg0LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IiZndDsiIHBvaW50cz0iMTU5LjA5MDkwOSAxNDguNTM4OTYxIDAgMjUwIDAgMTg3LjUgMTAyLjI3MjcyNyAxMjUuODExNjg4IDEwMi4yNzI3MjcgMTI0LjE4ODMxMiAwIDYyLjUgMCAwIDE1OS4wOTA5MDkgMTAxLjQ2MTAzOSI+PC9wb2x5Z29uPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTMxNy4zNTg0NTYsMjQuNTAyMjAxNyBMMTg5Ljc2LDI0LjUwMjIwMTcgTDE4OS43Niw0NS41MDkyNjQ1IEwyNDAuNTkxOTA1LDQ1LjUwOTI2NDUgTDI0MC41OTE5MDUsMjAzLjE5MTkwOSBMMjY1LjIyOTgxOCwyMDMuMTkxOTA5IEwyNjUuMjI5ODE4LDQ1LjUwOTI2NDUgTDMxNC43NjQ5OTEsNDUuNTA5MjY0NSBMMzE3LjM1ODQ1NiwyNC41MDIyMDE3IFogTTM4My40NDg1NzcsNjMuNDA0MTY5OSBDMzY2Ljg1MDQwNCw2My40MDQxNjk5IDM1NC4xNDI0MjgsNzMuNzc4MDI4MSAzNDYuODgwNzI3LDk0LjI2NjM5OCBMMzQ0LjU0NjYwOSw2Ni41MTYzMjczIEwzMjQuMDU4MjM5LDY2LjUxNjMyNzMgTDMyNC4wNTgyMzksMjAzLjE5MTkwOSBMMzQ3LjkxODExMywyMDMuMTkxOTA5IEwzNDcuOTE4MTEzLDEyNS4xMjg2MjYgQzM1My42MjM3MzUsOTguOTM0NjM0MSAzNjMuNDc4OSw4Ni43NDUzNTA4IDM4MC41OTU3NjYsODYuNzQ1MzUwOCBDMzg1LjUyMzM0OSw4Ni43NDUzNTA4IDM4OC4zNzYxNiw4Ny4yNjQwNDM3IDM5Mi41MjU3MDMsODguMzAxNDI5NSBMMzk2LjkzNDU5Myw2NC45NjAyNDg2IEMzOTIuNzg1MDQ5LDYzLjkyMjg2MjggMzg3Ljg1NzQ2Nyw2My40MDQxNjk5IDM4My40NDg1NzcsNjMuNDA0MTY5OSBMMzgzLjQ0ODU3Nyw2My40MDQxNjk5IFogTTUzOS42NjE1OTEsNjYuNTE2MzI3MyBMNTE1LjAyMzY3OCw2Ni41MTYzMjczIEw0NzkuMjMzODY4LDE4NS44MTU2OTYgTDQ0Mi42NjYwMTgsNjYuNTE2MzI3MyBMNDE3LjI1MDA2NSw2Ni41MTYzMjczIEw0NjMuMTU0Mzg3LDIwMy4xOTE5MDkgTDQ3MS4xOTQxMjgsMjAzLjE5MTkwOSBDNDYzLjQxMzczNCwyMjQuNDU4MzE4IDQ1NS42MzMzNCwyMzUuMDkxNTIzIDQyNy44ODMyNywyMzkuNzU5NzU5IEw0MzAuNDc2NzM0LDI1OC40MzI3MDQgQzQ2OC4zNDEzMTcsMjU0LjI4MzE2IDQ4NC40MjA3OTcsMjMzLjAxNjc1MSA0OTQuMDE2NjE2LDIwMy45Njk5NDggTDUzOS42NjE1OTEsNjYuNTE2MzI3MyBaIE02NTUuODkyMDI3LDEwOC4wMTE3NiBDNjcyLjQ5MDIwMSwxMDQuMTIxNTYzIDY4OC44MjkwMjcsOTIuMTkxNjI2MyA2ODguODI5MDI3LDY5LjM2OTEzODMgQzY4OC44MjkwMjcsMzUuNjU0MDk5MyA2NTkuMjYzNTMxLDIzLjQ2NDgxNTkgNjExLjAyNTA5MSwyMy40NjQ4MTU5IEw1NjAuMTkzMTg2LDIzLjQ2NDgxNTkgTDU2MC4xOTMxODYsMjAzLjE5MTkwOSBMNjE4LjAyNzQ0NSwyMDMuMTkxOTA5IEM2NjMuMTUzNzI4LDIwMy4xOTE5MDkgNjk2LjM1MDA3NCwxOTEuNzgwNjY1IDY5Ni4zNTAwNzQsMTUwLjgwMzkyNSBDNjk2LjM1MDA3NCwxMjEuNzU3MTIyIDY3NS44NjE3MDQsMTExLjkwMTk1NyA2NTUuODkyMDI3LDEwOC4wMTE3NiBMNjU1Ljg5MjAyNywxMDguMDExNzYgWiBNNjE3LjMzNTg1NSw1My41NDkwMDQ2IEM2MzcuODI0MjI1LDUzLjU0OTAwNDYgNjQ3LjY3OTM5LDU4LjQ3NjU4NzIgNjQ3LjY3OTM5LDczLjUxODY4MTYgQzY0Ny42NzkzOSw4OC41NjA3NzYgNjM4LjM0MjkxNyw5NS4zMDM3ODM4IDYyMC43MDczNTksOTUuMzAzNzgzOCBMNjA0Ljg4NzIyNSw5NS4zMDM3ODM4IEw2MDQuODg3MjI1LDUzLjU0OTAwNDYgTDYxNy4zMzU4NTUsNTMuNTQ5MDA0NiBaIE02MjAuNDQ4MDEyLDE3Mi4zMjk2ODEgTDYwNC44ODcyMjUsMTcyLjMyOTY4MSBMNjA0Ljg4NzIyNSwxMjMuNTcyNTQ3IEw2MjMuNTYwMTcsMTIzLjU3MjU0NyBDNjQxLjk3Mzc2OCwxMjMuNTcyNTQ3IDY1NC42ODE3NDQsMTMwLjMxNTU1NSA2NTQuNjgxNzQ0LDE0OC40Njk4MDcgQzY1NC42ODE3NDQsMTY4LjE4MDEzNyA2NDAuNDE3Njg5LDE3Mi4zMjk2ODEgNjIwLjQ0ODAxMiwxNzIuMzI5NjgxIEw2MjAuNDQ4MDEyLDE3Mi4zMjk2ODEgWiBNODI5Ljk1NjcyMywxNjMuMjUyNTU1IEw4MjkuOTU2NzIzLDEwOS44MjcxODUgQzgyOS45NTY3MjMsNzcuOTI3NTcxMyA4MTIuODM5ODU3LDYxLjA3MDA1MTggNzcyLjkwMDUwMyw2MS4wNzAwNTE4IEM3NTcuMzM5NzE2LDYxLjA3MDA1MTggNzM4LjQwNzQyNCw2NC43MDA5MDIyIDcyMS4wMzEyMTIsNzEuMTg0NTYzNSBMNzMwLjM2NzY4NCw5OC4xNTY1OTQ4IEM3NDQuMTEzMDQ2LDkzLjQ4ODM1ODYgNzU3LjU5OTA2Miw5MC44OTQ4OTQxIDc2Ni40MTY4NDIsOTAuODk0ODk0MSBDNzgzLjI3NDM2MSw5MC44OTQ4OTQxIDc4OS43NTgwMjIsOTUuODIyNDc2NyA3ODkuNzU4MDIyLDExMi4xNjEzMDMgTDc4OS43NTgwMjIsMTE4LjEyNjI3MiBMNzc1Ljc1MzMxNCwxMTguMTI2MjcyIEM3MzMuOTk4NTM1LDExOC4xMjYyNzIgNzExLjE3NjA0NywxMzQuNDY1MDk4IDcxMS4xNzYwNDcsMTY0LjU0OTI4NyBDNzExLjE3NjA0NywxODkuNzA1ODkzIDcyOC41NTIyNTksMjA3LjYwMDc5OSA3NTYuMDQyOTgzLDIwNy42MDA3OTkgQzc3Mi4zODE4MSwyMDcuNjAwNzk5IDc4Ny42ODMyNTEsMjAyLjE1NDUyMyA3OTcuNTM4NDE2LDE4Ny4xMTI0MjkgQzgwNC4wMjIwNzcsMjAwLjU5ODQ0NCA4MTQuNjU1MjgyLDIwNS41MjYwMjcgODMwLjczNDc2MiwyMDYuODIyNzU5IEw4MzkuMjkzMTk1LDE4MC4xMTAwNzQgQzgzMi44MDk1MzQsMTc3Ljc3NTk1NiA4MjkuOTU2NzIzLDE3My44ODU3NTkgODI5Ljk1NjcyMywxNjMuMjUyNTU1IEw4MjkuOTU2NzIzLDE2My4yNTI1NTUgWiBNNzY5LjA1MzUzLDE3OC4yOTQ2NDkgQzc1OC45MzkwMTksMTc4LjI5NDY0OSA3NTIuOTc0MDUsMTcxLjgxMDk4OCA3NTIuOTc0MDUsMTYwLjkxODQzNyBDNzUyLjk3NDA1LDE0Ny4xNzMwNzUgNzYyLjA1MTE3NiwxNDAuNjg5NDEzIDc4MC43MjQxMjEsMTQwLjY4OTQxMyBMNzkwLjgzODYzMywxNDAuNjg5NDEzIEw3OTAuODM4NjMzLDE2NS4zMjczMjYgQzc4NS45MTEwNSwxNzMuMzY3MDY3IDc3OC4zOTAwMDMsMTc4LjI5NDY0OSA3NjkuMDUzNTMsMTc4LjI5NDY0OSBMNzY5LjA1MzUzLDE3OC4yOTQ2NDkgWiBNOTE0LjM3Mzk5NCw2MS4wNzAwNTE4IEM4NzkuNjIxNTY5LDYxLjA3MDA1MTggODU4LjA5NTgxMyw3OS40ODM2NTAxIDg1OC4wOTU4MTMsMTAzLjA4NDE3NyBDODU4LjA5NTgxMywxMjQuMzUwNTg3IDg3MS41ODE4MjksMTM4LjM1NTI5NSA4OTguODEzMjA3LDE0Ni4xMzU2ODkgQzkyMy43MTA0NjYsMTUzLjEzODA0MyA5MjcuODYwMDA5LDE1NS45OTA4NTQgOTI3Ljg2MDAwOSwxNjUuMzI3MzI2IEM5MjcuODYwMDA5LDE3My42MjY0MTMgOTIwLjMzODk2MiwxNzguMjk0NjQ5IDkwNy44OTAzMzIsMTc4LjI5NDY0OSBDODk0LjQwNDMxNywxNzguMjk0NjQ5IDg4MS42OTYzNDEsMTcyLjg0ODM3NCA4NzEuMzIyNDgyLDE2NC44MDg2MzQgTDg1MS4zNTI4MDUsMTg3LjExMjQyOSBDODY0LjgzODgyMSwxOTkuMzAxNzEyIDg4NS4wNjc4NDQsMjA3LjYwMDc5OSA5MDguOTI3NzE4LDIwNy42MDA3OTkgQzk0My4xNjE0NSwyMDcuNjAwNzk5IDk3MC4xMzM0ODEsMTkwLjc0MzI3OSA5NzAuMTMzNDgxLDE2Mi4yMTUxNjkgQzk3MC4xMzM0ODEsMTM3LjU3NzI1NiA5NTQuODMyMDQxLDEyNi4xNjYwMTIgOTI3LjYwMDY2MywxMTguMzg1NjE4IEM5MDIuOTYyNzUsMTExLjEyMzkxOCA4OTkuMzMxODk5LDEwOC4wMTE3NiA4OTkuMzMxODk5LDEwMC43NTAwNTkgQzg5OS4zMzE4OTksOTQuNTI1NzQ0NCA5MDQuNzc4MTc1LDkwLjM3NjIwMTEgOTE1LjkzMDA3Myw5MC4zNzYyMDExIEM5MjcuODYwMDA5LDkwLjM3NjIwMTEgOTM5LjI3MTI1Myw5NC4yNjYzOTggOTQ5LjkwNDQ1OCwxMDEuMDA5NDA2IEw5NjQuOTQ2NTUyLDc3LjkyNzU3MTMgQzk1Mi4yMzg1NzYsNjcuNTUzNzEzMiA5MzQuMzQzNjcxLDYxLjA3MDA1MTggOTE0LjM3Mzk5NCw2MS4wNzAwNTE4IEw5MTQuMzczOTk0LDYxLjA3MDA1MTggWiBNMTA2OS42MzYwNyw2MS4wNzAwNTE4IEMxMDUzLjU1NjU5LDYxLjA3MDA1MTggMTA0MS4xMDc5Niw2Ny41NTM3MTMyIDEwMjkuOTU2MDYsODAuMDAyMzQzIEwxMDI5Ljk1NjA2LDYuNjA3Mjk2MzYgTDk4OC45NzkzMjQsMTAuNzU2ODM5NiBMOTg4Ljk3OTMyNCwyMDMuMTkxOTA5IEwxMDI5Ljk1NjA2LDIwMy4xOTE5MDkgTDEwMjkuOTU2MDYsMTA4Ljc4OTc5OSBDMTAzNy4yMTc3Niw5Ny42Mzc5MDE5IDEwNDQuNzM4ODEsOTEuMTU0MjQwNSAxMDUzLjgxNTk0LDkxLjE1NDI0MDUgQzEwNjEuNTk2MzMsOTEuMTU0MjQwNSAxMDY2Ljc4MzI2LDk1LjA0NDQzNzMgMTA2Ni43ODMyNiwxMDkuNTY3ODM5IEwxMDY2Ljc4MzI2LDIwMy4xOTE5MDkgTDExMDcuNzYsMjAzLjE5MTkwOSBMMTEwNy43NiwxMDIuNTY1NDg1IEMxMTA3Ljc2LDc2LjM3MTQ5MjYgMTA5My40OTU5NSw2MS4wNzAwNTE4IDEwNjkuNjM2MDcsNjEuMDcwMDUxOCBMMTA2OS42MzYwNyw2MS4wNzAwNTE4IFoiIGlkPSJUcnlCYXNoIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = " <div class=Container :class=\"{ turbo: turbo }\"> <header class=Header> <div class=Header-left> <a href=/ class=Logo> <img src=" + __webpack_require__(121) + " class=Logo-image alt=TryBash> </a> </div> <div class=Header-right> <tb-progress></tb-progress> </div> </header> <main class=Main> <div class=Main-container> <div class=Main-terminal> <tb-terminal></tb-terminal> </div> <div class=Main-task> <tb-task></tb-task> <div class=MadeBy> <div class=MadeBy-team>Built by the TryBash Team in Berlin</div> <div class=MadeBy-links> <a href=/impressum.html>Impressum</a> <a href=https://github.com/trybash/game> <svg xmlns=http://www.w3.org/2000/svg width=16 height=16 viewBox=\"0 0 16 16\" class=github-link><path fill=#ffffff d=\"M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0 0 16 8c0-4.42-3.58-8-8-8z\"/></svg>GitHub </a> </div> </div> </div> </div> </main> </div> <tb-done></tb-done> <tb-lesson-selection></tb-lesson-selection> ";

/***/ }),
/* 123 */
/***/ (function(module, exports) {

	module.exports = " <tb-modal :active=active> <div class=Done> <div class=Done-text>{{praises[praiseIndex]}}</div> <tb-button @click=nextSection v-el:next>Next Section →</tb-button> </div> </tb-modal> ";

/***/ }),
/* 124 */
/***/ (function(module, exports) {

	module.exports = " <div class=Modal :class=\"{'is-active': active}\"> <div class=Modal-content> <slot></slot> </div> <div class=Modal-backdrop></div> </div> ";

/***/ }),
/* 125 */
/***/ (function(module, exports) {

	module.exports = " <div class=ProgressBlocks> <div class=ProgressBlocks-title><slot></slot>:</div> <div class=ProgressBlock v-for=\"lesson in lessons\" track-by=$index :class=\"{\n    'is-done': lesson.done,\n    'is-active': lesson.active\n  }\"> {{ lesson.index + 1}} </div> </div> ";

/***/ }),
/* 126 */
/***/ (function(module, exports) {

	module.exports = " <div class=Task transition=Task- v-for=\"section in sections\" v-show=\"$index > 0\"> <h3 class=Task-headline>Current Task</h3> <div class=Task-text>{{{section.task}}}</div> </div> ";

/***/ }),
/* 127 */
/***/ (function(module, exports) {

	module.exports = " <tb-modal :active=selectionActive _v-46fc14c4=\"\"> <button class=LessonSelection-close @click=deactivateLessonSelection _v-46fc14c4=\"\"></button> <h2 _v-46fc14c4=\"\">Choose a lesson</h2> <p _v-46fc14c4=\"\"> You can do the excercises in any order you want – although it'd probably be wise to do them in order, if you are new to the Bash. </p> <ul class=Lessons _v-46fc14c4=\"\"> <li class=Lesson v-for=\"lesson in lessons\" _v-46fc14c4=\"\"> <div class=Lesson-left _v-46fc14c4=\"\"> {{lesson.title}} </div> <div class=Lesson-right _v-46fc14c4=\"\"> <tb-button :color=getColor(lesson) @click=\"lesson.active &amp;&amp; !lesson.done ? deactivateLessonSelection() : openLesson($index)\" _v-46fc14c4=\"\"> {{ getButtontext(lesson) }} </tb-button> </div> </li> </ul> <div class=LessonSelection-footer _v-46fc14c4=\"\"> <tb-button color=red @click=reset _v-46fc14c4=\"\">Reset all your data and start again</tb-button> </div> </tb-modal> ";

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	module.exports = " <div class=ProgressBar _v-496f0994=\"\"> <div class=ProgressBar-bar _v-496f0994=\"\"> <div class=ProgressBar-fill :style=\"{ width: fillWidth }\" _v-496f0994=\"\"> <div class=ProgressBar-fillPadding _v-496f0994=\"\"> {{ current }} / {{ max }} <slot _v-496f0994=\"\"></slot> </div> </div> <div class=ProgressBar-text _v-496f0994=\"\"> {{ current }} / {{ max }} <slot _v-496f0994=\"\"></slot> </div> </div> </div> ";

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	module.exports = " <div class=Terminal id=terminal @click=focusInput _v-57c9751c=\"\"> <div class=Terminal-front _v-57c9751c=\"\"> <div class=Terminal-screen v-el:terminal=\"\" _v-57c9751c=\"\"> <div class=History _v-57c9751c=\"\"> <pre v-for=\"line in output\" track-by=$index class=Step :class=\"{\n          'Step--error': line.type === 'ERR',\n          'Step--output': line.type === 'OUTPUT',\n          'Step--input': line.type === 'INPUT',\n          'Step--instruction': line.type === 'INSTRUCTION'\n        }\" _v-57c9751c=\"\">{{line.type === 'INPUT' ? '$ ' : '' }}{{line.text}}</pre> </div> <div class=Form _v-57c9751c=\"\"> <div class=Sign _v-57c9751c=\"\">$&nbsp;</div> <div class=InputWrapper _v-57c9751c=\"\"> <input class=Input v-model=command @keydown=keydown v-el:input=\"\" _v-57c9751c=\"\"> </div> </div> </div> <div class=Terminal-buttons _v-57c9751c=\"\"> <tb-button :color=\"turbo ? 'yellow' : 'grey'\" @click=toggleTurbo _v-57c9751c=\"\">Turbo</tb-button> <div class=Terminal-floppy _v-57c9751c=\"\"></div> <tb-button color=blue @click=activateLessonSelection _v-57c9751c=\"\">Lesson Selection</tb-button> </div> </div> </div> ";

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	module.exports = " <div class=Progress _v-5c15644d=\"\"> <tb-progress-blocks _v-5c15644d=\"\">Lessons</tb-progress-blocks> <tb-progress-bar :current=currentSection :max=maxSection _v-5c15644d=\"\">Sections</tb-progress-bar> </div> ";

/***/ }),
/* 131 */
/***/ (function(module, exports) {

	module.exports = " <button class=Button :class=\"{\n  red: color === 'red',\n  grey: color === 'grey',\n  yellow: color === 'yellow',\n  blue: color === 'blue'\n}\" _v-f1cabe5c=\"\"> <slot _v-f1cabe5c=\"\"></slot> </button> ";

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(101)
	__vue_script__ = __webpack_require__(40)
	__vue_template__ = __webpack_require__(122)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(102)
	__vue_script__ = __webpack_require__(42)
	__vue_template__ = __webpack_require__(123)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(106)
	__vue_script__ = __webpack_require__(43)
	__vue_template__ = __webpack_require__(127)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(109)
	__vue_script__ = __webpack_require__(45)
	__vue_template__ = __webpack_require__(130)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(107)
	__vue_script__ = __webpack_require__(46)
	__vue_template__ = __webpack_require__(128)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(104)
	__vue_script__ = __webpack_require__(47)
	__vue_template__ = __webpack_require__(125)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(105)
	__vue_script__ = __webpack_require__(48)
	__vue_template__ = __webpack_require__(126)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(108)
	__vue_script__ = __webpack_require__(49)
	__vue_template__ = __webpack_require__(129)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.d25853a6bfe03fc1a5d2.js